module.exports = __webpack_public_path__ + "static/img/top_home_1.b5128fcc.png";